import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-16">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="https://static.readdy.ai/image/6d0943092329599386bdfbaff4198b68/3843b12adf664db03f0d37a8ef9e817d.png" 
                alt="RDM Security Logo" 
                className="h-10 w-auto"
              />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              Premium <strong>home automation</strong> solutions in South East Florida and West Coast Tampa South. Certified experts in <strong>Control4, Savant, RTI, and Brilliant</strong> systems.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#4A90E2] flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#4A90E2] flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#4A90E2] flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">Home</a>
              </li>
              <li>
                <a href="/services" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">Services</a>
              </li>
              <li>
                <a href="/about" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">About Us</a>
              </li>
              <li>
                <a href="/contact" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">Contact</a>
              </li>
              <li>
                <a href="#blueprint" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">Upload Blueprint</a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base font-semibold mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="/services#control4" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">Control4 Integration</a>
              </li>
              <li>
                <a href="/services#savant" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">Savant Systems</a>
              </li>
              <li>
                <a href="/services#rti" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">RTI Control</a>
              </li>
              <li>
                <a href="/services#brilliant" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">Brilliant Smart Home</a>
              </li>
              <li>
                <a href="/services#fiber" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">Fiber Optic Installation</a>
              </li>
              <li>
                <a href="/services#security" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">Security Cameras</a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-[#4A90E2] mt-1"></i>
                <div>
                  <p className="text-xs text-gray-500 mb-1">Phone</p>
                  <a href="tel:+17862829701" className="text-sm text-gray-300 hover:text-[#4A90E2] transition-colors cursor-pointer">
                    (786) 282-9701
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-[#4A90E2] mt-1"></i>
                <div>
                  <p className="text-xs text-gray-500 mb-1">Email</p>
                  <a href="mailto:moshe@rdmsecurity.com" className="text-sm text-gray-300 hover:text-[#4A90E2] transition-colors cursor-pointer">
                    moshe@rdmsecurity.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#4A90E2] mt-1"></i>
                <div>
                  <p className="text-xs text-gray-500 mb-1">Service Area</p>
                  <p className="text-sm text-gray-300">
                    South East Florida<br />
                    West Coast Tampa South
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} RDM Security. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-[#4A90E2] transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
